// helper function to get the amount based on the deal amount
export const getAmount = (dealAmount) => {
  if (
    dealAmount === null ||
    dealAmount === undefined ||
    dealAmount === '' ||
    dealAmount === 0
  ) {
    return 12000;
  }

  let amount = 0;
  if (dealAmount < 6000) {
    amount = 0;
  } else if (dealAmount >= 6000 && dealAmount < 10000) {
    amount = 7620;
  } else if (dealAmount >= 10000 && dealAmount < 16500) {
    amount = 12420;
  } else if (dealAmount >= 16500 && dealAmount < 22500) {
    amount = 20240;
  } else if (dealAmount >= 22500) {
    amount = 25000;
  }
  return amount;
};
